export const SNACKBAR = {
  SNACKBAR_IS_OPEN: 'isOpen',
  SNACKBAR_IS_MESSAGE: 'message',
  SNACKBAR_IS_SEVERITY: 'severity',
}
